export function userSafeErrorMessage(caught: unknown, fallback: string) {
  const message = caught instanceof Error ? caught.message.trim() : "";
  if (
    !message ||
    message.length > 240 ||
    /(?:failed to fetch|networkerror|load failed|fetch failed|typeerror|referenceerror|syntaxerror|internal server|stack trace|econn|enotfound|cloudflare|\bD1\b|\bR2\b|\bKV\b|binding|webhook|api[_ -]?key|openai|json parse|sql|status code|http \d{3}|event destination|order subscription)/i.test(message)
  ) {
    return fallback;
  }
  return message;
}
